import { render } from "./SvgKingpinLandingGear.vue?vue&type=template&id=19140b12&ts=true"
import script from "./SvgKingpinLandingGear.vue?vue&type=script&lang=ts"
export * from "./SvgKingpinLandingGear.vue?vue&type=script&lang=ts"

import "./SvgKingpinLandingGear.vue?vue&type=style&index=0&id=19140b12&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__